import React from 'react'
import SearchCollgeBanner from './Componets/SearchCollgeBanner'
import SearchCollegeBody from './Componets/SearchCollegeBody'
import IndexFooter from '../Index/Components/IndexFooter'
// import TopBar from '../ProjectComponents/TopBar'
import SEOHelmet from '../ProjectComponents/SEOHelmet'

function SearchCollegePage() {
  const page = 'search-college'
  return (
    <>
        <SEOHelmet page={page} />
        {/* topbar */}
        <div className='bg-main main'>
          {/* <TopBar/> */}
          <SearchCollgeBanner/>
        </div>
        <SearchCollegeBody/>
        <IndexFooter/>
    </>
  )
}

export default SearchCollegePage